import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/comments': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M532 386.2c15.3 30.7 37.4 54.5 37.8 54.8 6.3 6.7 8 16.5 4.4 25-3.7 8.5-12 14-21.2 14-53.6 0-96.7-20.3-125.2-38.8-19 4.4-39 6.8-59.8 6.8-86.2 0-159.9-40.4-191.3-97.8-9.7-1.2-19.2-2.8-28.4-4.9-28.5 18.6-71.7 38.8-125.2 38.8-9.2 0-17.6-5.5-21.2-14-3.7-8.5-1.9-18.3 4.4-25 0.4-0.4 22.4-24.2 37.7-54.9-27.5-27.2-44-61.2-44-98.2 0-88.4 93.1-160 208-160 86.3 0 160.3 40.5 191.8 98.1 99.7 11.8 176.2 77.9 176.2 157.9 0 37.1-16.5 71.1-44 98.2zM139.2 293.9l19.8 4.5c16 3.7 32.5 5.6 49 5.6 86.7 0 160-51.3 160-112s-73.3-112-160-112-160 51.3-160 112c0 28.7 16.2 50.6 29.7 64l24.8 24.5-15.5 31.1c-2.6 5.1-5.3 10.1-8 14.8 14.6-5.1 29-12.3 43.1-21.4zM498.3 352c13.5-13.4 29.7-35.3 29.7-64 0-49.2-48.3-91.5-112.7-106 0.3 3.3 0.7 6.6 0.7 10 0 80.9-78 147.5-179.3 158.3 29.1 29.6 77.3 49.7 131.3 49.7 16.5 0 33-1.9 49-5.6l19.9-4.6 17.1 11.1c14.1 9.1 28.5 16.3 43.1 21.4-2.7-4.7-5.4-9.7-8-14.8l-15.5-31.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/comments.js
// module id = 1718
// module chunks = 0